import type { Talk } from "@/model/talk";

export type SortKey = "creation" | "updated";
export type SortDirection = "asc" | "desc";
export type SortConfig = {
  key: SortKey;
  direction: SortDirection;
  favoritePriority: boolean;
};

export const DEFAULT_SORT_CONFIG: SortConfig = {
  key: "updated",
  direction: "desc",
  favoritePriority: true,
};

// SortConfig にフィールドを追加したらここも更新すること
export function isSameSortConfig(a: SortConfig, b: SortConfig): boolean {
  return (
    a.key === b.key &&
    a.direction === b.direction &&
    a.favoritePriority === b.favoritePriority
  );
}

// ID は Number 精度を超えるため数値化せず、ロケール非依存の数値照合で比較する
const compareNumericStr = new Intl.Collator("en", { numeric: true }).compare;

function applySort(list: Talk[], config: SortConfig): Talk[] {
  const dir = config.direction === "asc" ? 1 : -1;
  // トークの作成順は talk_id_str で明示ソート（API返却順も talk_id 順のため表示は現行と同一）
  if (config.key === "creation") {
    return [...list].sort(
      (a, b) =>
        dir * compareNumericStr(a.talk_id_str ?? "", b.talk_id_str ?? ""),
    );
  }
  return [...list].sort((a, b) => {
    // max_message_id_str 省略時は 0 扱い
    const cmp = compareNumericStr(
      a.max_message_id_str ?? "0",
      b.max_message_id_str ?? "0",
    );
    return (
      dir *
      (cmp !== 0
        ? cmp
        : compareNumericStr(a.talk_id_str ?? "", b.talk_id_str ?? ""))
    );
  });
}

export function sortTalks(talks: Talk[], config: SortConfig): Talk[] {
  const sorted = applySort(talks, config);
  if (!config.favoritePriority) {
    return sorted;
  }
  // 並び順を保ったままお気に入りを先頭グループへ
  return [
    ...sorted.filter((t) => t.is_favorite === true),
    ...sorted.filter((t) => t.is_favorite !== true),
  ];
}
